import locale from "csi/locale";
import Delete from "csi/table/Delete";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const DeleteStyleBOMPlacementController = declare(Delete, {

	/**
     * @override
	 * If there are SourceBOMs linked to StyleBOM, warn user of unlinking the placements
	 * 	when deleting placements.
	 * 		
     */
	confirmAction(params: any): void {
		const cache = this.getCache();
		const apparelBom = cache.getNode(this.getParent().__Parent__);
		const linkedSourceBoms = apparelBom.LinkedSourceDataSheets;
		const linkedDSLineItemSysID = this.getNode().LinkedDSLineItemSysID;
		if (linkedDSLineItemSysID && !!linkedSourceBoms.length) {
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.title = locale.resource("UnlinkAndDeleteStyleBOMPlacement_Title");
			params.message = locale.resource("UnlinkAndDeleteStyleBOMPlacement_Confirm");
			this.m_action.confirmAction = MessageDialog.BUTTON_UNLINK_AND_DELETE;
		}

		this.inherited(arguments);
	},
});

export = DeleteStyleBOMPlacementController;